<template>
  <button
    class="page-menu-main-button flex flex-col items-center text-scheme-main tablet:text-primary whitespace-nowrap justify-center"
    :class="{
      '!text-white/50 tablet:!text-muted': isMuted,
      'active-link-popover': isOpen && id !== 'menu',
    }"
    @click.prevent="onClick"
    :data-testid="`nav-link-${id}`"
  >
    <div class="text-[24px] size-[1em] relative">
      <SpriteSymbol
        :name="icon"
        class="absolute top-0 left-0 size-full transition duration-300 ease-bounce"
        :class="{
          'scale-[0.3] opacity-0': isOpen,
        }"
      />
      <SpriteSymbol
        name="menu-close"
        class="absolute top-0 left-0 size-full transition duration-300 ease-swing"
        :class="{
          'scale-0 opacity-0 rotate-12': !isOpen,
        }"
      />
    </div>
    <span
      class="text-size-7 mt-2 leading-none font-bold transition duration-300"
      >{{ title }}</span
    >
  </button>
</template>

<script setup lang="ts">
import type { NuxtSvgSpriteSymbol } from '#nuxt-svg-sprite/runtime'

const props = defineProps<{
  id: string
  title: string
  icon: NuxtSvgSpriteSymbol
}>()

const { trackEvent } = useAnalytics()

const active = defineModel<string>()

const isOpen = computed(() => active.value === props.id)
const isMuted = computed(() => active.value && !isOpen.value)

function onClick() {
  if (isOpen.value) {
    active.value = ''
  } else {
    active.value = props.id
  }

  trackEvent({
    event: 'click_navbar_element',
    element_name: props.title,
    element_id: `navbar-link-${props.id}`,
    element_url: '',
  })
}
</script>

<style lang="postcss">
.page-menu-main-button {
  @apply relative;
  height: var(--page-menu-bottom);
  width: var(--page-menu-bottom);

  @screen tablet {
    &:last-child {
      /* Visually align the last button in the menu with the container. */
      margin-right: -0.8em;
    }

    &.active-link-popover:after {
      @apply bg-scheme-main absolute;
      box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
      content: '';
      height: 2rem;
      right: 0;
      top: 4.5rem;
      transform: translateX(-50%) rotate(45deg);
      width: 2rem;
      opacity: 0;
      animation: fadeIn 0.1s ease-in-out 0.1s forwards;
    }
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>
